import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import config from "../../config";

class Loader extends React.Component {
  render() {
    return (
      <>
        <div className="page-loader-wrapper">
          <div className="loader">
            <div className="m-t-30">
              <img
                className="zmdi-hc-spin"
                src={`${config.DOMAIN_URL}/assets/img/loader.gif`}
                width="120"
                height="auto"
                alt=" "
              />
            </div>
            <p className="font-weight-bold">Please wait...</p>
          </div>
        </div>
        <div class="overlay"></div>
      </>
    );
  }
}
export default Loader;
